import { ChangeDetectionStrategy, Component, ElementRef, EventEmitter, HostListener, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TemplateVersionSummary } from '../../../../../models/template-version/template-version.interface';
import { sourceLabel } from '../review-utils';

@Component({
  selector: 'app-review-version-bar-v2',
  imports: [CommonModule],
  templateUrl: './review-version-bar-v2.component.html',
  styleUrl: './review-version-bar-v2.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ReviewVersionBarV2Component implements OnChanges {
  @Input() versions: TemplateVersionSummary[] = [];
  @Input() viewing: number | null = null;
  @Input() latest: number | null = null;
  @Input() languageLabel = 'EN';

  @Output() selectVersion = new EventEmitter<number>();
  @Output() newVersion = new EventEmitter<void>();

  menuOpen = false;

  constructor(private hostElement: ElementRef) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['viewing']) {
      this.menuOpen = false;
    }
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent): void {
    if (this.menuOpen && !this.hostElement.nativeElement.contains(event.target as Node)) {
      this.menuOpen = false;
    }
  }

  pick(version: number): void {
    this.selectVersion.emit(version);
    this.menuOpen = false;
  }

  sourceLabel(version: TemplateVersionSummary): string {
    return sourceLabel(version);
  }
}
